/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortfolioCategory = {
    CaseStudy: 'CASE_STUDY',
    CreativeSample: 'CREATIVE_SAMPLE',
    ArticleInsight: 'ARTICLE_INSIGHT',
    PresentationTalk: 'PRESENTATION_TALK',
    ServiceOffering: 'SERVICE_OFFERING',
    CertificationReward: 'CERTIFICATION_REWARD'
} as const;
export type PortfolioCategory = typeof PortfolioCategory[keyof typeof PortfolioCategory];


export function instanceOfPortfolioCategory(value: any): boolean {
    for (const key in PortfolioCategory) {
        if (Object.prototype.hasOwnProperty.call(PortfolioCategory, key)) {
            // @ts-ignore
            if (PortfolioCategory[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioCategoryFromJSON(json: any): PortfolioCategory {
    return PortfolioCategoryFromJSONTyped(json, false);
}

export function PortfolioCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCategory {
    return json as PortfolioCategory;
}

export function PortfolioCategoryToJSON(value?: PortfolioCategory | null): any {
    return value as any;
}

